import { string, object } from "./";
import { phoneSchema } from "./phone";

export const safedealPayoutTiByCardSchema = object().shape({
  card_id: string().required(),
});

export const safedealPayoutTiBySbpSchema = object().shape({
  sbp_phone: phoneSchema.required(),
  sbp_member_id: string().required(),
});
